export const ProductionOrderSituationTypes = {
  pendente: 'pendente',
  aprovado: 'aprovado',
  em_separacao: 'em_separacao',
  producao: 'producao',
  pronta_entrega: 'pronta_entrega',
  finalizado: 'finalizado',
  cancelado: 'cancelado',
  pausado: 'pausado' 
}